import { useContext, useReducer } from 'react'
import { Outlet } from 'react-router-dom'
import { sponsorTypesReducer } from './sponsorTypesReducer'
import { sponsorTypesInitialState } from './sponsorTypesInitialState'
import SponsorTypesContext from './SponsorTypesContext'

export const useSponsorTypesContext = () => useContext(SponsorTypesContext)

export function SponsorTypesProvider() {
  const [sponsorTypesState, sponsorTypesDispatch] = useReducer(sponsorTypesReducer, sponsorTypesInitialState)

  return (
    <SponsorTypesContext.Provider value={{ sponsorTypesState, sponsorTypesDispatch }}>
      <Outlet />
    </SponsorTypesContext.Provider>
  )
}
